import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useWindowSize from '../CommonFunction/windowSize';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const widthWindow = useWindowSize().width;

  useEffect(() => {
    if (widthWindow < 768 || pathname.match(/my-rounds\/history/)) {
      window.scrollTo(0, 0);
    }
  }, [pathname, widthWindow]);

  return null;
}
